module.exports = __webpack_public_path__ + "static/img/pic66.133ff3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/pic66.jpg
// module id = i6Gv
// module chunks = 9